<template>
    <!-- 导航 -->
    <NavBar color="#343A41" bgcolor="white">
        <template v-slot:title>
            <span class="nav-title">我的订单</span>
        </template>
    </NavBar>
    <div class="head">
        <span class="check-item" :class="{active: ! state}" @click="changeState(null)">全部</span>
        <span class="check-item" :class="{active: state == states.waiting}" @click="changeState(states.waiting)">待支付</span>
        <span class="check-item" :class="{active: state == states.complete}" @click="changeState(states.complete)">已完成</span>
        <span class="check-item" :class="{active: state == states.cancel}" @click="changeState(states.cancel)">已取消</span>
    </div>
    <div class="date-box">
        <div class="cont-box" v-for="order in orders" :key="order.id">
            <div class="obj-box">
                <img class="img-item" :src="order.product.cover" />
                <section class="content">
                    <span class="title">{{ order.product.name }}</span>
                    <div class="pay-box">
                        <span class="pay">¥ {{ order.price }}</span>
                        <span class="pay-btn active" v-if="order.state == states.waiting" @click="payment(order)">去支付</span>
                        <span class="pay-btn" v-else-if="order.state == states.complete">已完成</span>
                        <span class="pay-btn" v-else-if="order.state == states.cancel">已取消</span>
                    </div>
                </section>
            </div>
            <div class="time" v-if="order.state == states.waiting">{{ order.diffMinute }}:{{ order.diffSecond }}后关闭</div>
        </div>
    </div>
    <div v-if="! loading && ! orders.length" class="list-null">
        <van-empty
            :image="require('@/assets/images/kong.png')"
            description="暂无订单"
            v-if="!$newYearStyle"/>
        <van-empty
            :image="require('@/assets/images1/newYear/kong.png')"
            description="暂无订单"
            v-else/>
    </div>

    <van-overlay :show="successType == 'common'" class="success-overlay">
        <div class="common">
            <img src="@/assets/images/close-detail-toast.png" class="close" @click="successType = ''">
            <p class="title">恭喜您成功抢到</p>
            <router-link :to="'/entity/' + entityKey" class="button">查看详情</router-link>
        </div>
    </van-overlay>

    <van-overlay :show="successType == 'unpack'" class="success-overlay">
        <div class="unpack">
            <img src="@/assets/images/blindbox.png" class="blindbox">
            <p class="title">藏品盲盒</p>
            <a href="javascript:;" class="button" @click="successType = 'confirm'">打开盲盒</a>
            <img src="@/assets/images/close.png" class="close" @click="successType = ''">
        </div>
    </van-overlay>

    <van-overlay :show="successType == 'confirm'" class="success-overlay">
        <div class="confirm">
            <img :src="openEntity.product.cover" class="cover">
            <p class="title">恭喜获得</p>
            <p class="title">{{openEntity.product.name}}</p>
            <a href="javascript:;" @click="$store.state.openEntity = true;$router.push('/entity/' + openEntity.id)" class="button">查看详情</a>
        </div>
    </van-overlay>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>